
import {
  defineComponent,
  PropType,
  reactive,
  watch,
  ref,
  computed
} from 'vue-demi'

type ListType = { value: string | number; label: string }[]

export default defineComponent({
  name: 'PopupRadio',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    options: {
      type: Array as PropType<ListType>,
      default: () => [],
      required: true
    },
    chosen: {
      type: [String, Number],
      required: true
    },
    filter: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    }
  },
  setup(props, { emit }) {
    const state = reactive({
      chosen: '' as string | number,
    })
    const searchData = ref('')


    watch(
      () => props?.chosen,
      () => {
        state.chosen = props.chosen
      }
    )
    const filterOptions = computed({
      get() {
        return !searchData.value ? props?.options : props?.options?.filter(item=> item.label?.toLowerCase()?.includes(searchData.value?.toLowerCase()))
      }
    })

    const handleClick = (chosen: string | number) => {
      state.chosen = chosen
      emit('change', chosen)
      handleClose()
    }
    const handleClose = () => {
      emit('input', false)
      searchData.value = ''
    }

    return {
      searchData,
      filterOptions,
      props,
      handleClick,
      handleClose
    }
  }
})
